import React, { useState } from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { withStyles, Typography, Grid, Paper, Tab, Tabs, Box, CircularProgress } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { useIntl } from "react-intl";
import useRefPeriods from "../services/useRefPoints";
import styles from "../styles";


const quarantinedColumns = [
  {
    name: "metering_point_id",
    label: "Id",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "reference_from",
    label: "Nuv. från",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "reference_to",
    label: "Nuv. till",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "groups",
    label: "Nuv. stråk",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "ref_error",
    label: "Nuv. fel",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "proposed_reference_period.ref_from",
    label: "Ny från",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "proposed_reference_period.ref_to",
    label: "Ny till",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "proposed_reference_period.ref_groups",
    label: "Ny stråk",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "proposed_reference_period.ref_error",
    label: "Ny fel",
    options: {
      filter: false,
      sort: true,
    },
  },  
]

const changedColumns = [
  {
    name: "metering_point_id",
    label: "Id",
  },
  {
    name: "ref_changed",
    label: "Ändrad",
  },
]

const withoutRefPeriodColumns = [
  {
    name: "_id",
    label: "Id",
  },
  {
    name: "start",
    label: "Startdatum mätvärden",
  },
    {
    name: "end",
    label: "Slutdatum mätvärden",
  },
]

const options = {
  selectableRows: 'none',  
  onRowClick: (rowData) => window.open("/meteringpoint/" + rowData[0], "_blank"),
}

const Loader = ({loading, children}) => {
  if (loading) {
    return <CircularProgress /> 
  }
  return <>{children}</>
}

const RefPeriodListPage = ({ classes }) => {
  const intl = useIntl();
  const [tabValue, setTabValue] = useState(0)
  const {loading, quarantined, changed, withoutRefPeriod} = useRefPeriods()

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="h5" color="textSecondary">
            <FormattedMessage id="refperiods" />
          </Typography>
        </Grid>        
        <Grid item xs={12} className={classes.StatusHeader}>
          <Loader loading={loading}>
            <Box>
              <Tabs value={tabValue} onChange={handleTabChange}>
                <Tab label="I karantän" />
                <Tab label="Senast ändrade" />
                <Tab label="Saknar referensperiod" />                
              </Tabs>
            </Box>
            { tabValue === 0 &&
              <Paper>
                <MUIDataTable
                  className={classes.PointerCursor}
                  data={quarantined}
                  columns={quarantinedColumns}
                  options={options}
                />
              </Paper>
            }
            { tabValue === 1 &&
              <Paper>
                <MUIDataTable
                  className={classes.PointerCursor}
                  data={changed}
                  columns={changedColumns}
                  options={options}
                />
              </Paper>
            }
            { tabValue === 2 &&
              <Paper>
                <MUIDataTable
                  className={classes.PointerCursor}
                  data={withoutRefPeriod}
                  columns={withoutRefPeriodColumns}
                  options={options}
                />
              </Paper>
            }            
          </Loader>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default withStyles(styles)(injectIntl(RefPeriodListPage));